import { Menu, Spin, Dropdown, message } from 'antd';
import { useEffect, useState, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { Link, useSelector, useHistory, useDispatch, useLocation } from 'troyfe';
import { CaretDownOutlined } from '@ant-design/icons';
import { LoginApi, UserApi, RefreshApi, PermissionApi } from 'gmrfid-service-user-api-client';
import { imgUrlHandle, arrayToTree } from '../../utils';
import { DropdownStyle, Block } from './style';
import { refreshFn } from '../../helper/unifiedLogin';
import defaultSettingsObj from '../../defaultSettings';
import store from '@/store';

const { defaultMenu } = defaultSettingsObj;

const { SubMenu } = Menu;
const iconBC = (name) => {
  if (name) {
    const Icon = require('@ant-design/icons')[name];
    if (Icon) {
      return <Icon />;
    }
    return '';
  }
};

const BaseMenu = (props) => {
  const userObj = JSON.parse(sessionStorage.getItem('user'));
  const [appState, appDispatchers] = store.useModel('app');
  const { basicInformation } = appState;

  // const dispatch = useDispatch();
  const locations = useLocation();
  // const { basicInformation } = useSelector((state) => state.app);
  const { userInf, organizationData } = basicInformation;
  const [dom, setDom] = useState(null);
  const history = useHistory();
  const [rootSubmenuKeys, setRootSubmenuKeys] = useState([]);
  const [selectKey, setSelectKey] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  const { organizeName, verifyState } = userInf;
  const dropDownRef = useRef(null);
  const [organizeId, setOrganizeId] = useState(null);
  const [tipText, setTipText] = useState('切换中...');
  const [tipType, setTipType] = useState(false);

  const getPath = (arr, id) => {
    return arr.reduce((total, item) => {
      if (item.id == id) {
        total.push(item);
      } else if (item.children && item.children.length) {
        const path = getPath(item.children, id);
        if (path && path.length) {
          total.unshift(item, ...path);
        }
      }
      return total;
    }, []);
  };
  /* 切换组织 */
  useEffect(() => {
    if (organizeId) {
      refreshFn(organizeId, history, true, setTipType, appDispatchers);
    }
  }, [organizeId]);

  const getSubId = (data) => {
    const arr = [];
    function son(data) {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        arr.push(item.id);
      }
    }
    son(data);
    return arr;
  };

  const deep = (data) => {
    if (data && data.length > 0) {
      return data.map((item) => {
        if (item.children && item.children.length > 0) {
          return (
            <SubMenu
              key={item.id}
              title={item.name}
              icon={
                item.icon ? (
                  <img
                    alt=""
                    style={{ width: 16, height: 16, marginRight: 8 }}
                    src={
                      // openKeys[0] === item.id
                      //   ? imgUrlHandle(item.icon2)
                      imgUrlHandle(item.icon)
                    }
                  />
                ) : (
                  <div style={{ width: 16, height: 16, marginRight: 8 }} />
                )
              }
            >
              {deep(item.children)}
            </SubMenu>
          );
        }
        const antIcon = true;
        // if (item.icon && item.icon.includes('http')) {
        //   antIcon = true;
        // }
        return (
          !item.show && (
            <Menu.Item
              key={item.id}
              icon={
                antIcon ? (
                  <img style={{ width: 16, height: 16, marginRight: 8 }} src={imgUrlHandle(item.icon)} alt="" />
                ) : (
                  <div
                    style={{
                      width: 16,
                      height: 16,
                    }}
                  >
                    {iconBC(item.icon)}
                  </div>
                )
              }
            >
              {item?.status === 'JY' ? (
                <span
                  onClick={() => {
                    message.warning('当前菜单已禁用');
                  }}
                >
                  {item.name}
                </span>
              ) : (
                <Link
                  to={item.uri}
                  onClick={() => {
                    window.goNavFn({
                      name: item.name,
                      uri: item.uri,
                      close: true,
                      state: item,
                    });
                  }}
                >
                  {item.name}
                </Link>
              )}
            </Menu.Item>
          )
        );
      });
    }
  };
  /* 根据pathname获取当前路由的菜单信息 */
  const getParentPath = (url, data) => {
    const arr = [];
    function dfs(data, url, parents) {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        // 找到id则返回父级id
        if (item.uri === url) {
          arr.push(item);
        } else if (item.children) {
          dfs(item.children, url);
        }
      }
    }
    dfs(data, url);
    return arr;
  };

  // 切换路由
  useEffect(() => {
    setRootSubmenuKeys(getSubId(props.routesData || []));
    setDom(deep(props.routesData || []));
  }, [props.routesData]);

  useEffect(() => {
    if (props.routesData?.length > 0 && locations.pathname) {
      const pathData = getParentPath(locations.pathname, props.routesData);
      if (pathData.length) {
        setSelectKey([pathData[0]?.id]);
        const pIdData = getPath(props.routesData, pathData[0]?.id);
        setOpenKeys(pIdData?.map((item) => item.id));
      } else {
        setSelectKey([]);
        setOpenKeys([]);
      }
    }
  }, [locations.pathname, props.routesData]);

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const organizationDome = (
    <DropdownStyle>
      <div className="title">切换组织</div>
      <ul className="organization-list" ref={dropDownRef}>
        {organizationData.map((item, i) => {
          const colorStyle = !!(item.verifyState && item.verifyState === 'VERIFIED');
          return (
            <li
              className="organization_item"
              onClick={() => {
                if (item.organizeId === userObj.organizeId) {
                  message.warning('当前已经是该组织登录~');
                } else {
                  setOrganizeId(item.organizeId);
                }
              }}
              key={i}
            >
              <img src="/organizationImg.png" alt="organization" />
              <div className="organization_text">
                <p>{item.organizeName}</p>
                <div
                  className="authentication"
                  style={{
                    color: colorStyle ? '#44bb55' : '#999999',
                    background: colorStyle ? 'rgba(68, 187, 85, 0.1)' : 'rgb(241,242,244)',
                  }}
                >
                  {item.verifyState === 'NOT_VERIFIED' ? '未认证' : '已认证'}
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </DropdownStyle>
  );
  const state = !!(verifyState && verifyState === 'VERIFIED');
  const style = {
    color: state ? '#44bb55' : '#999999',
    background: state ? 'rgba(68, 187, 85, 0.1)' : 'rgb(241,242,244)',
  };
  const title = state ? '已认证' : '未认证';
  return (
    <Block>
      {userObj?.organizeId && (
        <>
          <div className="organization">
            <img
              src={userInf && userInf.projectImg ? imgUrlHandle(userInf.projectImg) : '/organizationImg.png'}
              alt="img"
            />
            <div className="organization_text">
              <h1>
                {organizeName?.length > 7 ? `${organizeName.slice(0, 7)}...` : organizeName || '暂无楼盘信息'}
                <Dropdown overlay={organizationDome} trigger={['click']}>
                  <CaretDownOutlined className="switch" />
                </Dropdown>
              </h1>
              <div className="authentication" style={style}>
                {title}
              </div>
            </div>
          </div>
          <div className="line" />
        </>
      )}
      <Menu
        mode={props.mode}
        theme={props.theme}
        selectedKeys={selectKey}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
      >
        {dom}
      </Menu>
      {tipType && (
        <div className="shadow-box">
          <div className="shadow">
            <Spin
              tip={tipText}
              style={{
                color: '#fff',
              }}
            />
          </div>
        </div>
      )}
    </Block>
  );
};

export default withRouter(BaseMenu);
